import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageShell from './PageShell';
import Seo from '../components/Seo';
import { useI18n } from '../context/I18nContext';
import { publicApi } from '../api';
import { useApi } from '../hooks/useApi';
import { staticImg } from '../utils/media';
import { Spinner, EmptyState } from '../components/StateHelpers';
import { Download, ArrowRight, Gift } from 'lucide-react';

export default function FreeProducts() {
  const { lang, tr } = useI18n();
  const { data, loading } = useApi(() => publicApi.freeProducts(lang), [lang]);
  useEffect(() => { document.title = 'Ücretsiz Sistemler — Aegis Studios'; }, []);
  const items = data || [];

  return (
    <PageShell eyebrow={tr('free.eyebrow', 'ÜCRETSİZ SİSTEMLER')} title={<><span className="text-white">{tr('free.title1', 'Topluluğa')} </span><span className="gold-text">{tr('free.title2', 'Armağanlar')}</span></>} subtitle={tr('free.subtitle', 'Aegis ekibinin geliştirici topluluğu için ücretsiz olarak sunduğu modüler sistemler.')}>
      <Seo title={tr('free.title2', 'Armağanlar')} />
      <section className="pb-24">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
          {loading ? <Spinner /> : items.length === 0 ? (
            <EmptyState icon={Gift} title="Henüz ücretsiz ürün yok." />
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              {items.map((s) => (
                <article key={s.id} className="group relative rounded-2xl overflow-hidden border border-white/8 bg-gradient-to-b from-[#111015] to-[#0a090c] card-hover">
                  <Link to={`/free-products/${s.slug}`} className="block">
                    <div className="relative aspect-[16/10] overflow-hidden bg-[#0f0e12]">
                      <img src={staticImg(s.image)} alt={s.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition duration-700" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />
                      <div className="absolute top-4 left-4 px-3 py-1 text-[10px] font-black tracking-widest border rounded bg-emerald-500/15 border-emerald-500/40 text-emerald-300">ÜCRETSİZ</div>
                    </div>
                    <div className="p-6">
                      <div className="text-[10px] font-bold tracking-[0.3em] text-[#e4b44e]/80 mb-2">METIN2 SİSTEMLERİ</div>
                      <h3 className="font-display text-lg font-bold text-white leading-snug min-h-[3rem] line-clamp-2">{s.name}</h3>
                      <p className="text-sm text-white/60 mt-2 line-clamp-3">{s.short_description}</p>
                      <div className="mt-4 flex items-center justify-between">
                        <span className="font-display text-lg font-black gold-text">ÜCRETSİZ</span>
                        <span className="btn-outline-gold h-10 px-4 rounded-full text-xs font-extrabold tracking-widest inline-flex items-center gap-1.5">
                          <Download className="w-3.5 h-3.5" /> İNDİR <ArrowRight className="w-3.5 h-3.5" />
                        </span>
                      </div>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </PageShell>
  );
}
